'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = require('vue');

var Vue = _interopRequireWildcard(_vue);

var _kendoBaseComponentsVueWrapper = require('@progress/kendo-base-components-vue-wrapper');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-menu-item',
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('span', defaultSlot);
    },

    mixins: [_kendoBaseComponentsVueWrapper.KendoSharedMethods],
    props: {
        text: {
            type: String,
            default: undefined
        },
        cssClass: {
            type: String,
            default: undefined
        },
        url: {
            type: String,
            default: undefined
        },
        attr: {
            type: Object,
            default: undefined
        },
        encoded: {
            type: Boolean,
            default: undefined
        },
        content: {
            type: String,
            default: undefined
        },
        contentAttr: {
            type: Object,
            default: undefined
        },
        imageAttr: {
            type: Object,
            default: undefined
        },
        imageUrl: {
            type: String,
            default: undefined
        },
        items: {
            type: Array,
            default: undefined
        },
        spriteCssClass: {
            type: String,
            default: undefined
        },
        select: Function
    },
    mounted: function mounted() {
        this._resolveInnerChildren();
    },

    methods: {
        _resolveInnerChildren: function _resolveInnerChildren() {
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var hasItems = this.v3 ? !this.$props.items : this.$options.propsData && !this.$options.propsData['items'];
            if (hasItems && defaultSlot) {
                var items = this.resolveInnerTags('kendo-menu-item');
                this.subitems = items;
            }
        }
    }
};